import React, { useEffect, useState } from 'react';
import { func, object } from 'prop-types';

import Checkbox from 'apps/journey/components/checkbox';
import { QuestionBody } from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/styled-question';

const Boolean = ({ answer, handleChange, question }) => {
  const [activeOption, setActiveOption] = useState();

  useEffect(() => {
    setActiveOption(answer ? answer.boolean : null);
  }, [question.id]);

  const handleOnChange = ({ name }) => {
    if(name && activeOption === name) {
      handleChange({});
      setActiveOption();
    } else {
      setActiveOption(name);
      handleChange({target: { name: 'boolean', value: name }});
    }
  };

  return (
    <QuestionBody key={question.id} question={question} maxWidth={'334px'} >
      <Checkbox required isBool={true} key={question.id + 'true'} isChecked={activeOption === 'true'} name="true" label="Yes" handleChange={handleOnChange} />
      <Checkbox required isBool={true} key={question.id + 'false'} isChecked={activeOption === 'false'} name="false" label="No" handleChange={handleOnChange} />
    </QuestionBody>
  );
};

Boolean.propTypes = {
  answer: object,
  question: object,
  handleChange: func
};

Boolean.defaultProps = {
  answer: {}
};

export default Boolean;
